var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSakra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 554.26,
    height: 301.828,
    viewBox: "0 0 554.26 301.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17096",
    "data-name": "Group 17096",
    transform: "translate(9453 3455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12316",
    "data-name": "Path 12316",
    d: "M194.123-663.328a12.123,12.123,0,0,0-3.638,2.592c-2.41,2.41-4.184,6.912-5.275,13.461-1.5,9-1.273,34.107.5,48.113,1.592,12.779,4.911,21.874,9.641,26.194a9.459,9.459,0,0,0,5.548,2.91c6.367,1.455,11.187.637,13.961-2.319,4.184-4.5,5.684-14.871,4.047-28.331-.409-3.138-.819-10-1-15.234-.318-12.006.136-16.053,2.456-21.01a12.937,12.937,0,0,0,1.728-7.185c0-4.5-.728-6.185-4.548-10.05C210.631-661.236,200.126-665.375,194.123-663.328Z",
    transform: "translate(-9553.988 -2791.148)",
    fill: "#804277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12317",
    "data-name": "Path 12317",
    d: "M76.826-441.067c-3.956.955-46.476,1.364-53.161.455a88.917,88.917,0,0,0-9.141-.591c-4.138,0-4.729.091-6.685,1.228-4.275,2.547-6.185,6.139-6.594,12.46C.79-420.83,3.792-407.6,7.293-400.957c5.048,9.6,13.916,15.189,21.737,13.643,5.412-1.046,8.413-3.365,15.28-11.6,8.277-9.959,12.324-13.234,28.7-23.42,13.6-8.5,14.461-9.186,14.825-12.779a6.044,6.044,0,0,0-3.138-5.866C82.965-442.022,80.737-442.067,76.826-441.067Z",
    transform: "translate(-9454.199 -2912.226)",
    fill: "#d95768"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12318",
    "data-name": "Path 12318",
    d: "M204.387-407c-2.319,2.547-2.592,4.957-2,15.826.591,9.686,0,26.694-1.091,33.607-.637,3.956-1.137,5.639-3.865,13.006-1.41,3.82-1.728,11.733-.728,17.235,2.228,11.733,7.776,20.964,14.871,24.648,3.274,1.728,8.686,1.865,11.6.318,4.457-2.365,8.959-9.55,9.732-15.6.637-4.957.273-54.935-.409-58.436-1.91-9.55-5.957-16.69-14.1-24.83-5.275-5.23-7.731-6.776-11.005-6.776A3.583,3.583,0,0,0,204.387-407Z",
    transform: "translate(-9560.479 -2930.649)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12319",
    "data-name": "Path 12319",
    d: "M361.6-353.218a26.36,26.36,0,0,0-12.506,6.548c-5.139,4.911-6.867,9.5-6.548,17.508.182,4.457.364,5.366,1.592,7.958,3.365,7.14,9.05,10.414,25.785,14.825,8.959,2.319,13.734,4.457,15.6,6.867,1.728,2.274,2.046,6.867.637,9.641-2.183,4.229-7.413,6.23-15.371,5.866-7.458-.364-13.415-2.638-19.873-7.5a32.439,32.439,0,0,0-3.183-2.228c-.591-.227-8.231,8.595-8.231,9.5,0,.955,6.185,5.275,10.914,7.594,6.912,3.411,11.733,4.593,20.237,4.866,6.139.227,7.549.136,11.1-.728,12.369-2.956,19.373-11.278,19.373-23.056,0-12.1-6.912-18.645-24.557-23.193-14.871-3.865-18.736-5.957-20.055-10.732-1.137-4.366.909-8.459,5.321-10.641,3.274-1.592,8.731-2,13.688-.91a46.113,46.113,0,0,1,13.324,5.866,18.717,18.717,0,0,0,2.547,1.546c.045-.045,1.728-2.41,3.774-5.275l3.638-5.23-2.137-1.546a43.864,43.864,0,0,0-17.827-7.549C374.244-354.127,365.6-354.127,361.6-353.218Z",
    transform: "translate(-9638.655 -2960.147)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12320",
    "data-name": "Path 12320",
    d: "M517.935-351.09c-2.956,6.912-33.88,77.582-34.243,78.219-.364.773.091.819,6.821.819h7.231l4.138-9.686,4.093-9.641h38.336l4,9.55,4,9.55,7.413.136c6.912.091,7.367.045,7.094-.682-.182-.455-8.095-18.691-17.645-40.519L531.851-353h-13.1Zm14.052,30.605c3.593,8.231,6.594,15.371,6.685,15.78.227.773-.637.819-13.461.819-7.5,0-13.688-.136-13.688-.364-.045-.773,13.461-31.833,13.688-31.56C525.393-335.628,528.44-328.761,531.987-320.485Z",
    transform: "translate(-9717.226 -2960.637)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12321",
    "data-name": "Path 12321",
    d: "M691-312.526v40.474h14.1v-11.733l.046-11.687,6.412-6.594c5.366-5.5,6.458-6.458,6.912-5.866.273.364,6.5,8.595,13.825,18.281l13.37,17.6h8.368a74.389,74.389,0,0,0,8.368-.227c0-.136-7.776-10.459-17.281-22.92-9.5-12.506-17.281-22.829-17.281-23.011s4.775-5.275,10.641-11.324c5.821-6,13.324-13.779,16.644-17.235l6-6.23H743.888l-19.054,20.1c-10.459,11.1-19.191,20.191-19.373,20.282s-.364-8.959-.364-20.1V-353H691Z",
    transform: "translate(-9830.308 -2960.637)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12322",
    "data-name": "Path 12322",
    d: "M1070.3-350.408c-1.228,2.774-31.969,73.125-33.379,76.4l-.819,1.955h14.325l4.093-9.686,4.093-9.641,19.145-.136,19.1-.091,4.047,9.641L1105-272.28l7.413.136c4.547.045,7.367-.046,7.231-.318-.046-.227-8-18.463-17.645-40.474L1084.486-353H1071.48Zm14.6,30.514c3.683,8.595,6.639,15.689,6.5,15.826-.091.091-6.321.136-13.87.091l-13.643-.136,6.867-16.053c3.774-8.822,7-15.871,7.14-15.689C1078.074-335.628,1081.212-328.489,1084.9-319.894Z",
    transform: "translate(-10018.469 -2960.637)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12323",
    "data-name": "Path 12323",
    d: "M871-311.854v40.292h13.643v-28.2h17.963l9.777,13.916c5.366,7.685,10,14.007,10.232,14.1.273.136,4,.136,8.322.091l7.822-.136-10.687-14.962c-5.912-8.231-10.55-15.143-10.368-15.28a17.571,17.571,0,0,1,2.638-1.137c9.459-3.411,15.28-11.187,15.962-21.51.864-12.915-6.185-22.511-19.236-26.1-3.365-.955-4.684-1-24.784-1.182L871-352.1Zm42.156-26.422A12.357,12.357,0,0,1,922.07-326c.045,6-3,10.414-8.731,12.688-2.41.955-3.32,1.046-15.6,1.182l-13.1.136v-27.422l13.1.182C908.472-339.048,911.2-338.912,913.156-338.275Z",
    transform: "translate(-9928.45 -2961.128)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12324",
    "data-name": "Path 12324",
    d: "M356-136.373c-.136.318-1.319,3.865-2.683,7.867-1.5,4.457-2.547,7-2.729,6.549-.182-.364-1.273-3.774-2.456-7.5l-2.183-6.776-1.955-.136c-1.683-.136-1.91-.045-1.683.682.136.455,1.774,5.093,3.593,10.368l3.365,9.55h3l2.547-7.367c1.364-4.047,2.683-7.231,2.82-7.049s1.364,3.547,2.683,7.458l2.41,7.185h2.956l3.456-10.141c1.91-5.548,3.456-10.232,3.456-10.459,0-.182-.773-.318-1.683-.318h-1.728l-2.41,7.549c-1.319,4.138-2.547,7.458-2.683,7.322s-1.319-3.593-2.592-7.685l-2.41-7.413-1.41-.136C356.773-136.919,356.136-136.737,356-136.373Z",
    transform: "translate(-9640.147 -3078.491)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12325",
    "data-name": "Path 12325",
    d: "M440.639-136.2A10.628,10.628,0,0,0,434-126.238c0,6.367,4.184,10.5,10.687,10.5,6.458,0,10.687-4.184,10.687-10.5a10.549,10.549,0,0,0-5.685-9.55C447.779-136.789,442.822-137.016,440.639-136.2Zm7.458,3.5c3.5,1.955,4.82,7.231,2.638,10.414-1.728,2.5-3.32,3.411-6.048,3.411-4,0-6.594-2.547-6.958-6.776a6.119,6.119,0,0,1,.955-4.5A6.781,6.781,0,0,1,448.1-132.7Z",
    transform: "translate(-9690.179 -3078.576)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12326",
    "data-name": "Path 12326",
    d: "M823.834-136.408c-2.228.728-5.594,4.229-6.276,6.5-2.046,6.958,1.956,13.324,9,14.143a10.765,10.765,0,0,0,11.778-13.1C837.022-135,830.338-138.454,823.834-136.408Zm8.049,3.865a7.57,7.57,0,0,1,2.865,6.321c0,7.14-8.277,10.05-12.551,4.411-1.137-1.455-1.319-2.092-1.319-4.548,0-3.183.773-4.639,3.456-6.458A7.188,7.188,0,0,1,831.884-132.542Z",
    transform: "translate(-9899.02 -3078.411)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12327",
    "data-name": "Path 12327",
    d: "M895.559-136.209a5.423,5.423,0,0,0-3.092,5.775c.273,2.956,1.455,4,6.412,5.5a15.48,15.48,0,0,1,4.229,1.728c1.046,1.319,1,2.183-.136,3.365-1,1-1.455,1.137-3.593.955a8.777,8.777,0,0,1-4.184-1.364l-1.728-1.137-1,1.273c-1.182,1.41-1.091,1.5,2.137,3.183,2.865,1.455,7.731,1.5,10.05.091a5.285,5.285,0,0,0,2.683-4.911c0-3.411-1-4.32-7.049-6.367-3.775-1.273-4.093-1.455-4.229-2.638-.364-2.91,3.274-4,6.958-2.137l1.819.955,1-1.273,1-1.228-1.228-.819C902.881-137.073,898.242-137.528,895.559-136.209Z",
    transform: "translate(-9939.775 -3078.428)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12328",
    "data-name": "Path 12328",
    d: "M1117.838-127.314c-2.274,5.275-4.32,10-4.457,10.414-.273.682-.045.819,1.5.819,1.728,0,1.819-.045,2.683-2.41l.91-2.365h10.232l1,2.365c.955,2.365,1,2.41,2.82,2.41h1.91l-4.593-10.459L1125.3-137h-3.274Zm9,2c.364,1.046.318,1.046-3.229,1.046h-3.593l1.546-3.684c.91-2.046,1.728-3.911,1.865-4.138C1123.7-132.5,1125.205-129.451,1126.842-125.313Z",
    transform: "translate(-10060.553 -3078.41)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12329",
    "data-name": "Path 12329",
    d: "M511-125.768v10.232h3.638v-7.276h2.41l2.365.045,2.456,3.593c2.456,3.638,2.456,3.638,4.457,3.638,2.319,0,2.319.136-1-4.548-1.864-2.638-2-3-1.319-3.411a19.16,19.16,0,0,0,2.183-1.683c1.319-1.137,1.41-1.41,1.41-4.366,0-5.412-1.728-6.458-10.687-6.458H511Zm12.142-6.367a3.257,3.257,0,0,1,.864,4.275c-.91,1.683-1.455,1.865-5.775,1.865h-3.593v-6.821h3.774C521-132.817,522.46-132.589,523.142-132.135Z",
    transform: "translate(-9732.163 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12330",
    "data-name": "Path 12330",
    d: "M578-125.768v10.232h14.552v-3.183H581.638V-136H578Z",
    transform: "translate(-9768.694 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12331",
    "data-name": "Path 12331",
    d: "M639-125.768v10.232h4.911c6.321,0,8-.5,10.6-3.138a9.932,9.932,0,0,0-2.274-16.053c-2.274-1.182-2.774-1.273-7.822-1.273H639Zm11.733-6.139a8.605,8.605,0,0,1,3.274,6.139,9.694,9.694,0,0,1-1,3.411c-1.41,2.683-3.32,3.638-7.276,3.638h-3.092v-14.1h3.32C648.459-132.817,649.6-132.589,650.733-131.907Z",
    transform: "translate(-9801.954 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12332",
    "data-name": "Path 12332",
    d: "M749-125.768v10.232h3.638v-8.64h10v8.64h3.638V-136h-3.638v8.64h-10V-136H749Z",
    transform: "translate(-9861.931 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12333",
    "data-name": "Path 12333",
    d: "M956-125.768v10.232h3.638v-6.821h3.547c2.774,0,3.865-.227,5.321-1.046a6.694,6.694,0,0,0-.227-11.778c-1.228-.637-2.774-.819-6.912-.819H956Zm11.1-6.094c1.046.819,1.228,1.273,1.091,2.82-.182,2.5-1.546,3.456-5.5,3.82l-3.047.273v-7.867h3.138C965.232-132.817,966.141-132.635,967.1-131.862Z",
    transform: "translate(-9974.796 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12334",
    "data-name": "Path 12334",
    d: "M1020-125.768v10.232h3.638V-136H1020Z",
    transform: "translate(-10009.691 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12335",
    "data-name": "Path 12335",
    d: "M1057-134.408v1.592h6.367v17.281H1067v-17.235l3.32-.136,3.274-.136.137-1.5.136-1.455H1057Z",
    transform: "translate(-10029.865 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12336",
    "data-name": "Path 12336",
    d: "M1188-125.768v10.232h14.552v-3.183h-10.914V-136H1188Z",
    transform: "translate(-10101.292 -3078.955)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12337",
    "data-name": "Path 12337",
    d: "M338.036-68l.136,1.046,200.458.136,200.412.091V-69H337.9Z",
    transform: "translate(-9637.782 -3115.486)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12338",
    "data-name": "Path 12338",
    d: "M408-35.042v7.958h1.364c.955,0,1.364-.227,1.364-.773,0-.637.091-.637.91.091a3.945,3.945,0,0,0,5.321-.364c1.592-1.546,2-5.73.819-8.186a3.931,3.931,0,0,0-6.321-1.41c-.682.637-.728.409-.728-2.274v-3H408Zm7.458-.591c1.455,2.046.591,6.048-1.41,6.549-1.546.409-2.365-.091-3.138-1.865-1.137-2.774.182-5.684,2.592-5.684A2.333,2.333,0,0,1,415.458-35.633Z",
    transform: "translate(-9676.003 -3129.662)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12339",
    "data-name": "Path 12339",
    d: "M345.007-35.861c0,6,0,6.139-1.137,6.867-1.046.682-1.228.682-2.319-.045-1.091-.682-1.273-.728-1.91-.045-.637.637-.637.773.091,1.592,1.637,1.819,5.912,1.364,7.049-.773.273-.546.5-3.638.5-7.322V-42h-2.274Z",
    transform: "translate(-9638.477 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12340",
    "data-name": "Path 12340",
    d: "M364.892-34.46c2.547,7.458,2.638,7.64,3.911,7.64,1.228,0,1.319-.182,3.911-7.64l2.592-7.594h-1.228c-1.182,0-1.319.227-3.274,6L368.8-30l-1.91-5.912c-1.819-5.73-1.91-5.912-3.229-6.048L362.3-42.1Z",
    transform: "translate(-9651.086 -3130.153)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12341",
    "data-name": "Path 12341",
    d: "M475.5-41.416a3.5,3.5,0,0,0-2.046,3.547c0,2.228.728,3.092,4.138,4.729,3.138,1.5,3.82,2.683,2.456,4.093-1,.955-2.365.91-4.366-.136-1.683-.91-2.683-.637-2.683.728s4.32,2.638,6.821,1.955A3.863,3.863,0,0,0,483-30.593c0-2.228-.773-3.092-4.138-4.729-2.41-1.182-2.91-1.592-2.91-2.547,0-1.683,1.774-2.41,3.775-1.546,2,.819,2.046.819,2.729-.273.5-.864.409-1-1-1.592C479.594-42.1,476.775-42.143,475.5-41.416Z",
    transform: "translate(-9711.444 -3130.246)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12342",
    "data-name": "Path 12342",
    d: "M502-34.269v7.731h9.55v-1.137c0-1.137-.046-1.137-3.638-1.137h-3.638V-33.36h3.183c2.865,0,3.183-.091,3.183-.91s-.318-.91-3.183-.91h-3.183v-4.548h3.638c3.593,0,3.638,0,3.638-1.137V-42H502Z",
    transform: "translate(-9727.256 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12343",
    "data-name": "Path 12343",
    d: "M531.576-41.129c-5.184,3.411-4.138,13.052,1.592,14.6a7.586,7.586,0,0,0,6.094-1.137c.819-.637.819-.728.136-1.455-.682-.682-.864-.682-2.319.045-2.274,1.046-2.956.91-4.684-.819-1.364-1.364-1.546-1.819-1.546-3.865,0-2.592.91-4.775,2.228-5.5a4.819,4.819,0,0,1,4.457.227c.91.637,1.046.591,1.683-.318.682-.955.637-1.046-.546-1.819A7.948,7.948,0,0,0,531.576-41.129Z",
    transform: "translate(-9741.553 -3130.214)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12344",
    "data-name": "Path 12344",
    d: "M560.673-40.848c-2,1.728-2.774,3.5-2.774,6.549-.045,4.5,2,7.276,5.821,8,2.228.409,5.548-1.364,6.685-3.638,1.91-3.774.682-9.5-2.456-11.324A7.172,7.172,0,0,0,560.673-40.848Zm7.413,3.411a6.715,6.715,0,0,1,.637,4c-.136,2.092-.409,2.683-1.637,3.774-1.592,1.41-3,1.592-4.5.546-3.32-2.319-3.047-8.913.455-10.369C565.039-40.348,566.994-39.575,568.086-37.438Z",
    transform: "translate(-9757.734 -3130.177)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12345",
    "data-name": "Path 12345",
    d: "M594-34.269v7.731h2.274v-5.275c0-3.274.182-5.139.455-4.957a19.087,19.087,0,0,1,2.092,3.183c.91,1.637,1.819,2.865,2,2.729a20.735,20.735,0,0,0,2.137-3.32l1.728-3.047.136,5.366.136,5.321h2.228V-42H605.96c-1.137,0-1.5.455-3.274,3.729l-2,3.684-2-3.684C596.865-41.636,596.5-42,595.319-42H594Z",
    transform: "translate(-9777.419 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12346",
    "data-name": "Path 12346",
    d: "M644.729-41.09c-1,1-1.228,3.547-.409,5.048.364.773.227,1.137-.909,2.183A3.578,3.578,0,0,0,642-30.767a3.982,3.982,0,0,0,3.183,4.275c1.546.455,2,.409,3.684-.409,1.819-.91,2-.91,2.774-.273.773.728,2.183.591,2.183-.227a4.423,4.423,0,0,0-.864-1.455c-.864-1.046-.864-1.091,0-2.774,1.046-2.092,1.046-2.046-.045-2.319-.728-.182-1.046.091-1.5,1.137l-.546,1.319-1.319-1.364-1.319-1.364,1.455-1.364C652.46-38.18,651.141-42,647.457-42A3.721,3.721,0,0,0,644.729-41.09Zm4.229,1.865c.546.91-.637,3.138-1.683,3.138-.955,0-1.728-2.183-1.137-3.229A1.625,1.625,0,0,1,648.958-39.226ZM647.912-31.5c1.455,1.819,1.5,1.91.637,2.547a3.467,3.467,0,0,1-2.228.5c-1.819-.182-2.547-2.046-1.41-3.729.409-.637.909-1.182,1.137-1.182A8.092,8.092,0,0,1,647.912-31.5Z",
    transform: "translate(-9803.59 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12347",
    "data-name": "Path 12347",
    d: "M685-40.863c0,1.046.182,1.137,2.046,1.137h2.046v13.188h2.274V-39.726h2.047c1.865,0,2.046-.091,2.046-1.137V-42H685Z",
    transform: "translate(-9827.035 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12348",
    "data-name": "Path 12348",
    d: "M714.351-41.063c-2.183,1.364-3.411,4.411-3.183,7.822.318,4.32,2.91,7,6.776,6.912,2.774-.045,4.366-1.091,5.775-3.82,1.91-3.774.819-9-2.274-10.914A7.538,7.538,0,0,0,714.351-41.063Zm6.458,2.774c2.274,2.683,1.41,8.459-1.455,9.55-2.456.955-4.684-.546-5.548-3.684C712.35-37.834,717.534-42.2,720.809-38.289Z",
    transform: "translate(-9841.288 -3130.235)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12349",
    "data-name": "Path 12349",
    d: "M744.829-37.225c2.5,4.457,2.683,4.911,2.683,7.731,0,2.865.045,2.956,1.137,2.956s1.137-.091,1.137-3.047c0-2.82.182-3.32,2.5-7.458,1.364-2.41,2.5-4.548,2.5-4.684S754.2-42,753.469-42a1.684,1.684,0,0,0-1.819,1.228,26.347,26.347,0,0,1-1.819,3.456l-1.273,2.228-1.774-3.456C745.147-41.727,744.92-42,743.555-42H742.1Z",
    transform: "translate(-9858.169 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12350",
    "data-name": "Path 12350",
    d: "M775.081-40.955c-3.138,2.092-4.138,7.094-2.183,11.051a6.354,6.354,0,0,0,10.232,1.819c3.593-3.593,2.865-11.142-1.182-13.233A7.34,7.34,0,0,0,775.081-40.955Zm6.458,2.41c1.364,1.455,1.728,5.775.728,7.776a3.887,3.887,0,0,1-6.821.455c-1.182-1.5-1.319-5.5-.318-7.367A3.9,3.9,0,0,1,781.539-38.545Z",
    transform: "translate(-9874.415 -3130.207)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12351",
    "data-name": "Path 12351",
    d: "M805-40.863c0,1.046.182,1.137,2.046,1.137h2.046v13.188h2.274V-39.726h2.046c1.865,0,2.046-.091,2.046-1.137V-42H805Z",
    transform: "translate(-9892.465 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12352",
    "data-name": "Path 12352",
    d: "M831.025-34.86C829.57-30.9,828.3-27.4,828.16-27.084c-.136.455.136.591,1.046.455,1-.091,1.41-.5,1.819-1.728l.546-1.592,3.183-.136,3.183-.136.591,1.865c.5,1.546.773,1.819,1.865,1.819h1.273l-1.592-4.457c-.91-2.41-2.183-5.912-2.819-7.731C836.21-41.682,835.982-42,834.891-42,833.708-42,833.526-41.636,831.025-34.86Zm5.184-.227.955,2.638h-2.319c-1.683,0-2.274-.182-2.137-.591.136-.273.591-1.637,1.046-2.956.409-1.364.955-2.274,1.137-2.046A19.012,19.012,0,0,1,836.21-35.088Z",
    transform: "translate(-9905.074 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12353",
    "data-name": "Path 12353",
    d: "M874-40.863c0,1.046.182,1.137,2.047,1.137h2.046v13.188h2.274V-39.726h2.047c1.864,0,2.046-.091,2.046-1.137V-42H874Z",
    transform: "translate(-9930.086 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12354",
    "data-name": "Path 12354",
    d: "M902.883-41.162a4.49,4.49,0,0,0-1.728,2.274c-.818,2.456.091,3.774,3.865,5.684,3.411,1.683,4,2.683,2.683,4.138-1,1.091-2.274,1.091-4.366,0-1.637-.819-1.728-.819-2.41-.045s-.682.864.318,1.546c2.774,1.955,7.276,1.819,8.777-.318.819-1.182.91-3.956.137-5a14.13,14.13,0,0,0-3.547-2.228c-2.41-1.228-3-1.728-3.092-2.729-.227-1.819,1.546-2.183,5.184-1.046,1.228.409,1.865-1,.909-1.955C908.659-41.845,904.384-42.027,902.883-41.162Z",
    transform: "translate(-9944.508 -3130.363)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12355",
    "data-name": "Path 12355",
    d: "M929-36.225c0,5.048.136,6,.909,7.322,2.365,3.82,8.459,3.411,10.05-.682a37.3,37.3,0,0,0,.409-6.776V-42H938.1v5.684c0,5.457-.045,5.775-1.137,6.821-1.864,1.91-4.32,1.319-5.184-1.182a31.086,31.086,0,0,1-.5-6.367V-42H929Z",
    transform: "translate(-9960.073 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12356",
    "data-name": "Path 12356",
    d: "M962.5-41.416a3.5,3.5,0,0,0-2.046,3.547c0,2.228.728,3.092,4.138,4.729,3.138,1.5,3.82,2.683,2.456,4.093-1,.955-2.365.91-4.366-.136-1.683-.91-2.683-.637-2.683.728s4.32,2.638,6.821,1.955A3.863,3.863,0,0,0,970-30.593c0-2.228-.773-3.092-4.138-4.729-2.41-1.182-2.91-1.592-2.91-2.547,0-1.683,1.774-2.41,3.775-1.546,2,.819,2.046.819,2.729-.273.5-.864.409-1-1-1.592C966.594-42.1,963.775-42.143,962.5-41.416Z",
    transform: "translate(-9976.977 -3130.246)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12357",
    "data-name": "Path 12357",
    d: "M989-34.269v7.731h1.137c1.091,0,1.137-.091,1.137-3.183V-32.9h6.367v3.183c0,3.092.045,3.183,1.137,3.183h1.137V-42h-1.137c-1.046,0-1.091.136-1.228,3.274l-.136,3.32-3.047.136-3.092.136v-3.456c0-3.32-.045-3.411-1.137-3.411H989Z",
    transform: "translate(-9992.789 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12358",
    "data-name": "Path 12358",
    d: "M1023.081-40.955c-3.138,2.092-4.138,7.094-2.183,11.051a6.354,6.354,0,0,0,10.232,1.819c3.593-3.593,2.865-11.142-1.182-13.233A7.34,7.34,0,0,0,1023.081-40.955Zm6.458,2.41c1.364,1.455,1.728,5.775.728,7.776a3.887,3.887,0,0,1-6.821.455c-1.182-1.5-1.319-5.5-.318-7.367A3.9,3.9,0,0,1,1029.539-38.545Z",
    transform: "translate(-10009.635 -3130.207)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12359",
    "data-name": "Path 12359",
    d: "M1083.209-35.906c0,4.957-.136,6.276-.728,6.821-.909.91-1.546.91-2.865-.045-1-.682-1.137-.682-1.682.091-.773,1.046-.455,1.5,1.5,2.365a4.348,4.348,0,0,0,5.184-1.046c1.046-1.091,1.091-1.546,1.228-7.731l.136-6.549h-2.774Z",
    transform: "translate(-10041.066 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12360",
    "data-name": "Path 12360",
    d: "M1103.025-34.86c-1.455,3.956-2.728,7.458-2.865,7.776-.136.455.136.591,1.046.455,1-.091,1.41-.5,1.819-1.728l.546-1.592,3.183-.136,3.183-.136.591,1.865c.5,1.546.773,1.819,1.864,1.819h1.273l-1.592-4.457c-.91-2.41-2.183-5.912-2.819-7.731-1.046-2.956-1.273-3.274-2.365-3.274C1105.709-42,1105.526-41.636,1103.025-34.86Zm5.184-.227.955,2.638h-2.319c-1.682,0-2.274-.182-2.137-.591.136-.273.591-1.637,1.046-2.956.409-1.364.955-2.274,1.137-2.046A19.046,19.046,0,0,1,1108.21-35.088Z",
    transform: "translate(-10053.38 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12361",
    "data-name": "Path 12361",
    d: "M1135-34.424v7.776h1.364c1.364,0,1.364-.045,1.364-2.456v-2.456l2.592-.182c2.183-.182,2.774-.455,3.865-1.683a5.072,5.072,0,0,0-.046-6.958c-1.273-1.455-1.5-1.5-5.23-1.683L1135-42.2Zm7.276-4.5c2.047,2.046.455,5-2.729,5h-1.819v-5.912h1.819A3.721,3.721,0,0,1,1142.276-38.926Z",
    transform: "translate(-10072.395 -3130.098)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12362",
    "data-name": "Path 12362",
    d: "M1164.23-41.373c-.091.318-1.319,3.684-2.729,7.458-1.364,3.774-2.5,7-2.5,7.185,0,.136.5.273,1.091.273.819,0,1.228-.409,1.819-1.819l.728-1.819h6l.682,1.819c.591,1.5.955,1.819,1.955,1.819h1.228l-2.774-7.594c-2.638-7.14-2.865-7.64-4.047-7.776C1164.958-41.919,1164.366-41.737,1164.23-41.373Zm3.183,7.731c.318,1.273.273,1.273-1.774,1.273-1.137,0-2.092-.182-2.092-.409a22.853,22.853,0,0,1,1-3.047l1-2.638.773,1.819A16.436,16.436,0,0,1,1167.413-33.642Z",
    transform: "translate(-10085.479 -3130.289)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12363",
    "data-name": "Path 12363",
    d: "M1194-34.269v7.731h2.228l.136-5.321.136-5.366L1200-31.9c2.956,4.5,3.729,5.366,4.684,5.366h1.137V-42h-2.274v5c0,2.729-.136,5-.318,5-.227,0-1.865-2.274-3.683-5-2.729-4.138-3.456-5-4.411-5H1194Z",
    transform: "translate(-10104.563 -3130.208)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12364",
    "data-name": "Path 12364",
    d: "M436.046-27.225c1.137,3.229,1.955,6.094,1.819,6.367-.091.318-.819.591-1.592.591-1.819,0-1.955,1.637-.182,2.092,2.274.591,3.411-.91,5.73-7.594,1.182-3.365,2.137-6.367,2.137-6.685C444-32.727,443.5-33,442.913-33c-1,0-1.228.409-2.456,4.184l-1.319,4.229-1.273-4.229C436.638-32.773,436.5-33,435.273-33H434Z",
    transform: "translate(-9690.179 -3135.115)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12365",
    "data-name": "Path 12365",
    d: "M1053.516-12.818a2.318,2.318,0,0,0,.773,1.774c.682.5.637.637-.227,1.5-1.182,1.182-1.228,1.455-.318,1.455,1.364,0,2.5-1.728,2.5-3.865,0-1.955-.045-2.046-1.364-2.046C1053.7-14,1053.516-13.818,1053.516-12.818Z",
    transform: "translate(-10027.745 -3145.474)",
    fill: "#41447c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12366",
    "data-name": "Path 12366",
    d: "M-9257.18-2679.952s-6.715,2.3-5.414,8.723,11.489,7.893,11.489,7.893,13.318.641,21.4,0,22.789-2.4,22.789-2.4l28.993-4.934,11.557-3.555s13.271-5.821,7.2-15.655-20.063-18.059-20.063-18.059a26.951,26.951,0,0,0-9.612-3.751c-2.952-.4-7.412-1.385-13.68.5a24.864,24.864,0,0,0-6.222,3.249,31.6,31.6,0,0,0-4.649,5.175c-1.744,3.4-1.57,4.79-3.441,8.281s-9.788,6.192-9.788,6.192l-8.78,3.106s-6.034,1.575-12.3,3.282A57.2,57.2,0,0,1-9257.18-2679.952Z",
    transform: "translate(-73.258 -675.986)",
    fill: "#44aa8a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSakra);
export default __webpack_public_path__ + "static/media/logo-sakra.f99bf56abdca1fb4fdd9cdc7fd0815c1.svg";
export { ForwardRef as ReactComponent };